import { isEmpty, lowerCase } from "lodash";
import { cdnImg } from "../../Utils/cdnImage";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import LiveMatchTracker from "../Score/ScoreBoard";
import { RxCross2 } from "react-icons/rx";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { formatNumber, formatWithCommas } from "../../Utils/Toast";
import { isMobile } from "react-device-detect";
import { getDomain } from "../../Utils/constants";
import ThemeContext from "../../context/ThemeContext";
import LiveMatchTrackerTennis from "../Score/Tennis/ScoreBoard";
import LiveMatchTrackerCricket from "../Score/Cricket/ScoerBoardDetail";
import LiveMatchTrackerSoccer from "../Score/Soccer.js/ScoreBoardSoccer";
const ListingSports = ({
  heading,
  data,
  showScore,
  handleScore,
  isSportTab,
  addToFavioute,
  activeFav,
}) => {
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const navigate = useNavigate();
  let tabPosition = {
    cricket: "bottom",
    tennis: "top",
    soccer: "bottom",
  };
  const displayScore = ({ object }) => {
    return <iframe
      style={{ width: "100%", height: "141px", position: `relative` }}
      src={object?.scoreCustomUrl}
    />

  };
  return (
    <div data-v-88ac4f64 className="s-flex s-flex-col s-px-7px s-mb-12px">
      {isSportTab == "all" && (
        <div
          data-v-88ac4f64
          className="s-h-35px s-flex s-justify-start s-items-center s-bg-primary s-rounded-t-5px s-px-10px"
        >
          <i
            data-v-88ac4f64
            className={`s-mr-5px s-text-16px s-text-main-tab-text-active s-icon-${lowerCase(
              heading,
            )}`}
          />
          <p
            data-v-88ac4f64
            className="s-text-15px s-font-bold s-text-main-tab-text-active s-leading-16px"
          >
            {heading}
          </p>
        </div>
      )}
      <div
        data-v-88ac4f64
        className="s-w-full s-shadow-2sm s-divide-y s-divide-black-100 dark:s-divide-main-divide-dark s-border-solid"
      >
        {data?.map((res) => {
          let animate = activeFav?.includes(res?.eventId);
          return (
            <div
              data-v-01c3d0b5
              data-v-88ac4f64
              onClick={() => {
                if (parlay) {
                  navigate(
                    `/match-detail/${res?.eventId}/${res?.marketId}/multi`,
                  );
                } else {
                  navigate(`/match-detail/${res?.eventId}/${res?.marketId}`);
                }
              }}
              className="s-overflow-hidden s-rounded-b-5px"
            >
              <div
                data-v-01c3d0b5
                className={`s-event-block-item-row s-px-10px s-py-7px s-grid s-gap-10px s-justify-center s-items-center s-bg-white dark:s-bg-main-block-dark s-rounded-b-5px ${isMobile ? "isDefaultMobile" : "isDefaultDesktop"
                  }`}
                data-is-inplay-type={!parlay ? "false" : "true"}
                data-icons={1}
                data-animate-star={!parlay ? "true" : "false"}
              >
                <div data-v-01c3d0b5>
                  {!parlay && (
                    <div
                      data-v-01c3d0b5
                      className="s-w-16px s-flex s-justify-center s-items-center s-scale-110"
                    >
                      <div
                        style={{
                          color: theme == "dark" ? "#ffb80c" : "white",
                        }}
                        data-v-5460a16b
                        data-v-88ac4f64
                        onClick={(e) => {
                          if (res?.runners?.length > 0) {
                            e.preventDefault();
                            e.stopPropagation();
                            addToFavioute(
                              res?.eventId,
                              "Match Odds",
                              res?.marketId,
                              res?.eventType,
                            );
                          }
                        }}
                        className={`s-fav s-relative s-text-15px ${res?.runners?.length > 0
                            ? "s-text-icon-dark dark:s-text-global-font-default-dark"
                            : "s-text-black-300 dark:s-opacity-15 "
                          } `}
                      >
                        <div
                          data-v-5460a16b
                          className={`s-relative s-icon-star${animate ? "-solid s-animate-star-line-box" : ""
                            }`}
                        >
                          <span
                            data-v-5460a16b
                            className={`s-rating-star-line s-bg-icon-dark dark:s-bg-global-font-default-dark ${animate ? "s-animate-star-line" : ""
                              }`}
                          />
                          <span
                            data-v-5460a16b
                            className={`s-rating-star-line s-bg-icon-dark dark:s-bg-global-font-default-dark ${animate ? "s-animate-star-line" : ""
                              }`}
                          />
                          <span
                            data-v-5460a16b
                            className={`s-rating-star-line s-bg-icon-dark dark:s-bg-global-font-default-dark ${animate ? "s-animate-star-line" : ""
                              }`}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  data-v-01c3d0b5
                  className="s-flex s-justify-center s-items-start s-flex-col"
                >
                  <p
                    data-v-01c3d0b5
                    className="s-w-full s-text-17px s-font-bold s-leading-140 s-truncate s-text-global-font-default-light dark:s-text-global-font-default-dark"
                  >
                    {res?.eventName}
                  </p>
                  <div
                    data-v-01c3d0b5
                    className="s-py-2px s-flex s-gap-3px s-justify-start s-items-center"
                  >
                    {res?.status == "in_play" ? (
                      <div
                        data-v-88ac4f64
                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                      >
                        <div className="s-px-3px s-leading-14px s-flex s-items-center s-justify-center s-bg-inPlay-light dark:s-bg-inPlay-dark s-text-black s-flex-1">
                          <span className="s-text-12px s-leading-120 s-text-center">
                            In-play
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        data-v-88ac4f64
                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                      >
                        <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-today-light dark:s-bg-today-dark">
                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                            {isDateToday(res?.eventDateTime)
                              ? "Today"
                              : moment(res?.eventDateTime).format("DD/MM")}
                          </span>
                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                            {moment(res?.eventDateTime).format("HH:MM")}
                          </span>
                        </div>
                      </div>
                    )}
                    {!parlay && (
                      <div
                        data-v-88ac4f64
                        className="s-flex s-justify-center s-items-center s-gap-2px"
                      >
                        {res?.status == "in_play" && (
                          <div>
                            <img
                              src={cdnImg("/assets/IconBetting/streaming.svg")}
                              alt="streaming"
                              className="s-h-14px"
                            />
                          </div>
                        )}

                        {res?.hasFancy && (
                          <div>
                            <img
                              src={cdnImg("/assets/IconBetting/fancybet.svg")}
                              alt="fancybet"
                              className="s-h-14px"
                            />
                          </div>
                        )}
                        {res?.hasBookmaker && (
                          <div>
                            <img
                              src={cdnImg("/assets/IconBetting/bookmaker.svg")}
                              alt="bookmaker"
                              className="s-h-14px"
                            />
                          </div>
                        )}

                        {res?.hasSportBook && (
                          <div>
                            <img
                              src={cdnImg("/assets/IconBetting/sportsbook.svg")}
                              alt="geniusSports"
                              className="s-h-14px"
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {!parlay && res?.totalMatched > 0 && (
                      <p
                        style={{ color: "white", fontWeight: "600" }}
                        data-v-88ac4f64
                        className="s-text-12px s-leading-120 s-text-black-600"
                      >
                        {" "}
                        Matched{" "}
                        <span data-v-88ac4f64>
                          {formatWithCommas(res?.totalMatched)}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
                <div
                  data-v-01c3d0b5
                  className="s-flex s-gap-10px s-justify-end s-items-center"
                >
                  {res?.hasOwnProperty('scoreId') &&
                    res.scoreId != null &&
                    res.scoreId !== 0 &&
                    res.scoreId !== "0" && (
                      <span
                        style={{
                          color: theme == "light" ? "white" : "rgb(255, 184, 12)",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleScore(res?.scoreId);
                        }}
                        data-v-01c3d0b5
                        className={`s-text-16px dark:s-text-[#ededed] ${showScore?.includes(res?.scoreId)
                            ? "s-icon-h2h-solid"
                            : "s-icon-h2h"
                          } `}
                      />
                    )}
                  <span
                    style={{
                      color: theme == "light" ? "white" : "rgb(255, 184, 12)",
                    }}
                    data-v-01c3d0b5
                    className="s-icon-arrow-left s-transform s-rotate-180 s-text-12px s-text-black-400 dark:s-text-black-600"
                  />
                </div>
              </div>
              {showScore?.includes(res?.scoreId) && (
                <div
                  style={{ position: "relative" }}
                  className="s-bg-black-300 dark:s-bg-white dark:s-bg-opacity-5 s-p-7px s-border-t s-border-black-400 dark:s-border-black-900"
                >
                  <RxCross2
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleScore(res?.scoreId);
                    }}
                    size={17}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "10px",
                    }}
                  />
                  {displayScore({ object: res })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingSports;
